
import { Component, Vue } from 'vue-property-decorator'
import TechSidebar from './tech-sidebar.vue'
import TechTopbar from './tech-topbar.vue'

@Component({
    name: 'TechLayout',
    components: { TechSidebar, TechTopbar }
})
export default class TechLayout extends Vue {}
